import { render, staticRenderFns } from "./SourceLogo.vue?vue&type=template&id=23c31102&scoped=true"
import script from "./SourceLogo.vue?vue&type=script&lang=js"
export * from "./SourceLogo.vue?vue&type=script&lang=js"
import style0 from "./SourceLogo.vue?vue&type=style&index=0&id=23c31102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c31102",
  null
  
)

export default component.exports